import { render, staticRenderFns } from "./change-channel-modal.vue?vue&type=template&id=04ea8f6c&"
import script from "./change-channel-modal.vue?vue&type=script&lang=ts&"
export * from "./change-channel-modal.vue?vue&type=script&lang=ts&"
import style0 from "./change-channel-modal.vue?vue&type=style&index=0&id=04ea8f6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports